import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import {
    formulaHeader,
    chanceHeader,
    formulaText,
    unitbetrange,
    // ftBetTypeText,
    ftcLangFn, setFtCalcBetVaue,
    allupchance
} from '../Common/FTCalcBetcal';
import { NewWindow } from '../../Common/home-common';
import ArrowIcon from '../../Common/ui-components/ArrowIcon';
import CloseButton from '../../Common/ui-components/CloseButton';
import { useWindowSize } from '../../Common/CommonHooks';
import { IsBetTypeEnabled } from '../../Common/ChannelParaFunc';
import { useBroadcastChannel } from '../../Common/hooks';
import { useActivateUser } from '../../BetSlip/SsoHook';

let betTypeText = [
    [
        {betType: "HAD" ,text:'HAD (主客和)'},
        {betType: "FHA" ,text:'FHAD (半場主客和)'},
        {betType: "HHA" ,text:'HHAD (讓球主客和)'},
        {betType: "HDC" ,text:'HDC (讓球)'},
        {betType: "FHH" ,text:'FHDC (半場讓球)'},
        {betType: "HIL" ,text:'HILO (入球大細)'},
        {betType: "HLH" ,text:"球隊入球大細"},
        {betType: "FHL" ,text:'FHL (半場入球大細)'},
        {betType: "FLH" ,text:'球隊半場入球大細'},
        {betType: "CHL" ,text:'CHLO (開出角球大細)'},
        {betType: "CHH" ,text:'球隊開出角球大細'},
        {betType: "FCH" ,text:'FCHLO (半場開出角球大細)'},
        {betType: "CFH" ,text:'球隊半場開出角球大細'},
        {betType: "CHD" ,text:'CHDC (開出角球讓球)'},
        {betType: "FHC" ,text:'FCHDC (半場開出角球讓球)'},
        {betType: "CRS" ,text:'CRS (波膽)'},
        {betType: "FCS" ,text:'FCS (半場波膽)'},
        {betType: "FTS" ,text:'FTS (第一隊入球)'},
        {betType: "TTG" ,text:'TTG (總入球)'},
        {betType: "OOE" ,text:'OOE (入球單雙)'},
        {betType: "FGS" ,text:'FGS (首名入球)'},
        {betType: "NGS" ,text:'NGS (下一名入球球員)'},
        {betType: "LGS" ,text:'LGS (最後入球球員)'},
        {betType: "AGS" ,text:'AGS (任何時間入球球員)'},
        {betType: "HFT" ,text:'HFT (半全場)'}
    ],
    [
        {betType: "HAD" ,text: 'HAD (Home/Away/Draw)'},
        {betType: "FHA" ,text: 'FHAD (First Half HAD)'},
        {betType: "HHA" ,text: 'HHAD (Handicap HAD)'},
        {betType: "HDC" ,text: 'HDC (Handicap)'},
        {betType: "FHH" ,text: 'FHDC (First Half Handicap)'},
        {betType: "HIL" ,text: 'HILO (HiLo)'},
        {betType: "HLH" ,text: 'Team HiLo'},
        {betType: "FHL" ,text: 'FHL (First Half HiLo)'},
        {betType: "FLH" ,text: 'First Half Team HiLo'},
        {betType: "CHL" ,text: 'CHLO (Corner Taken HiLo)'},
        {betType: "CHH" ,text: 'Team Corner Taken HiLo'},
        {betType: "FCH" ,text: 'FCHLO (First Half Corner Taken HiLo)'},
        {betType: "CFH" ,text: 'First Half Team Corner Taken HiLo'},
        {betType: "CHD" ,text: 'CHDC (Corner Taken Handicap)'},
        {betType: "FHC" ,text: 'FCHDC (First Half Corner Taken Handicap)'},
        {betType: "CRS" ,text: 'CRS (Correct Score)'},
        {betType: "FCS" ,text: 'FCS (First Half Correct Score)'},
        {betType: "FTS" ,text: 'FTS (First Team to Score)'},
        {betType: "TTG" ,text: 'TTG (Total Goals)'},
        {betType: "OOE" ,text: 'OOE (Odds Even)'},
        {betType: "FGS" ,text: 'FGS (First Scorer)'},
        {betType: "NGS" ,text: 'NGS (Next Scorer)'},
        {betType: "LGS" ,text: 'LGS (Last Scorer)'},
        {betType: "AGS" ,text: 'AGS (Anytime Scorer)'},
        {betType: "HFT" ,text: 'HFT (HaFu)'},
    ]
];

const formatBetType = (item) => {
    let formatBetType=item.split(' ')?.[0];
        if(formatBetType=='FHDC'){
            item='FHH'
        } else if(formatBetType=='FCHDC'){
            item='FHC'
        }
    return item;
}

const filterBetTypeText = () => {
    let ftBetTypeText = [];
    ftBetTypeText[0] = betTypeText[0].filter((item) => {
        return IsBetTypeEnabled(item.betType)
    });
    ftBetTypeText[1] = betTypeText[1].filter((item) => {
        return IsBetTypeEnabled(item.betType)
    });
    if(!ftBetTypeText[0]?.length){
        ftBetTypeText = betTypeText // No data returned from the backend
    }
    return ftBetTypeText;
};

const FTCalculator = () => {
    const ftBetTypeText = filterBetTypeText();

    const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const langIndex = lang === 'en' ? 1 : 0;
    const navigate = useNavigate();

    const [curBetType, setCurBetType] = useState('');
    const [curAllupFormula, setCurAllupFormula] = useState('');
    const [curUnitBet, setCurUnitBet] = useState(null);
    const [curLegChance, setCurLegChance] = useState(['', '']);
    const [curBetChance, setCurBetChance] = useState([0, 1, 0, 0, 0, 0, 0, 0]);
    const [curLegSelect, setCurLegSelect] = useState([1, 1]);
    const [selection, setSselection] = useState([1, 2, 3]);
    const [curFormulaText, setCurFormulaText] = useState([]);
    const { isMobileSize } = useWindowSize();
    const broadcast_resetlogin = useBroadcastChannel('resetLoginTimeout');
    useActivateUser({
        activateUser: () => {
            if (window.globalConfig.NEW_LOGOUT_REMINDER_FLOW) {
                broadcast_resetlogin?.postMessage(false)
            }
        }
    });

    useEffect(() => {
        if (ftBetTypeText[langIndex][0]) {
            setCurBetType(ftBetTypeText[langIndex][0]);
        } else {
            setCurBetType(false);
        }

        ftcLangFn(langIndex);
    }, []);

    useEffect(() => {
        if(!curBetType) return
        let type = curBetType.betType;
        let selNum = 3;
        let max6Leg = window.fbConfig.allupInfo[type] == 6;
        if (['HAD', 'FHA', 'HHA', 'FTS'].includes(type)) {
            selNum = 3;
        }
        if (['HDC', 'HIL', 'FHL', 'CHL', 'FCH', 'OOE', ...window.fbConfig.TeamGoalLinePools].includes(type)) {
            selNum = 2;
        }
        if (['CRS', 'FCS'].includes(type)) {
            selNum = 33;
        }
        if (['TTG'].includes(type)) {
            selNum = 8;
        }
        if (window.fbConfig.GSPools.includes(type)) {
            selNum = 59;
        }
        if (['AGS'].includes(type)) {
            selNum = 58;
        }
        if (['HFT'].includes(type)) {
            selNum = 9;
        }
        if (max6Leg) {
            setCurFormulaText(formulaText[langIndex].slice(0, 41));
        } else {
            setCurFormulaText(formulaText[langIndex]);
        }
        setSselection(Array.from(new Array(selNum + 1).keys()).slice(1));
        setCurAllupFormula(formulaText[langIndex][0]);
        setCurUnitBet(unitbetrange[0]);
        setCurLegSelect([1, 1]);
        setFtCalcBetVaue([0, 1, 1], 'legchance');
        setCurBetChance([0, 1, 0, 0, 0, 0, 0, 0]);
    }, [curBetType]);

    useEffect(() => {
        let length = curAllupFormula.slice(0, 1) - 0;
        setFtCalcBetVaue(curAllupFormula, 'selectedFormula');
        if (length === 0) {
            return;
        }
        const arr = [1, 1, 1, 1, 1, 1, 1, 1];
        if (curLegChance.length !== length || !isMobileSize) {
            const newArr = arr.slice(0, length);
            setCurLegChance(newArr);
            let newSelArr = [];
            if (length > curLegChance.length) {
                const addNum = length - curLegChance.length;
                const addArr = arr.slice(0, addNum);
                newSelArr = [...curLegSelect, ...addArr];
            } else {
                newSelArr = [...curLegSelect.slice(0, length)];
            }
            setCurLegSelect(newSelArr);
            setFtCalcBetVaue([0, ...newSelArr], 'legchance');
            if (document.querySelector('.ftCalTable')) {
                document.querySelector(
                    '.ftCalTable'
                ).style.gridTemplateColumns = `112px repeat(${newSelArr.length}, 88px)`;
            }
        } 
        ftcLangFn(langIndex);
        calcAllupBetFn();
    }, [curAllupFormula, isMobileSize]);

    const calcAllupBetFn = () => {
        setFtCalcBetVaue('', 'allupchanceFn');
        setCurBetChance(allupchance.slice(1));
    };

    const handleChangeSelect = (value, selectType, index) => {
        if (selectType === 'betType') {
            setCurBetType(value);
        } else if (selectType === 'formula') {
            setCurAllupFormula(value);
        } else if (selectType === 'unitBet') {
            setCurUnitBet(value);
        } else if (selectType === 'legSelection') {
            let newlegSelect = [...curLegSelect];
            newlegSelect[index] = value;
            setCurLegSelect(newlegSelect);
            setFtCalcBetVaue([0, ...newlegSelect], 'legchance');
            calcAllupBetFn();
        }
    };

    const getChance = () => {
        let num = 0;
        curBetChance.map((item) => {
            num = num + item;
        });
        return num;
    };

    const getTotalAmount = () => {
        let num = 10;
        num = getChance() * curUnitBet;
        return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    };

    const handleClickBack = () => {
        navigate(-1);
    };

    const formatBetTypeLabel = (text) => {
        if (!text) {
            return '';
        }
        let newText = text;
        if (window.innerWidth < 769) {
            if(newText.includes('(')){
                newText = newText.split('(')[1].split(')')[0];
            }
        }
        return newText;
    };

    const goToFBComb = () => {
        const url = `/${lang}/football/bet_six`;
        const w = isMobileSize ? null : 828;
        const h = isMobileSize ? null : 561;
        NewWindow(url, 'Int_All Up Combinations', w, h);
    };

    const HeaderRightUI = () => {
        return (
            <div className="dfFe">
                <div className="allUpComb" onClick={goToFBComb}>
                    {t('LB_FB_TITLE_ALL_UP_COMBINATIONS')}
                </div>
                <div className="ftCalcBtn" onClick={goToFBComb}>
                    <div className="ftCalcIcon"></div>
                </div>
            </div>
        );
    };


    const flexiFontSize = (totalAmount) =>{
        if(!isMobileSize) return 15
        if(totalAmount.length > 21){
            return 12
        }else if(totalAmount.length > 18){
            return 13
        }else if(totalAmount.length > 15){
            return 14
        }
        return 15
    }

    return (
        curBetType && (
            <div className="FTCalculator">
                <div className="ftCalcContainer">
                    <div className={`ftCalcTitle ${isMobileSize?'popupTitle':''}`}>
                        <div>{t('LB_FB_INVESTMENT_CALCULATOR')}</div>
                        {!isMobileSize && <HeaderRightUI />}
                        {isMobileSize && <CloseButton isIOSPWA={true} />}
                    </div>
                    {isMobileSize && <HeaderRightUI />}
                    <div className="ftCalcBetComb">
                        <div className="dfr">
                            <DropdownButton
                                title={
                                    <div className="dfr">
                                        <span>{t('LB_BET_TYPE')} : </span>
                                        <div className="dfc">{formatBetTypeLabel(curBetType.text)}</div>
                                        <ArrowIcon direction="down" size={24} />
                                    </div>
                                }
                                align="end"
                                id="ftBetTypeText"
                                value={curBetType.text}
                            >
                                {ftBetTypeText[langIndex].map((item, index) => {
                                    return (
                                        <Dropdown.Item
                                            value={item}
                                            onClick={() => handleChangeSelect(item, 'betType')}
                                            active={curBetType.text === item.text}
                                            key={item}
                                        >
                                            {formatBetTypeLabel(item.text)}
                                        </Dropdown.Item>
                                    );
                                })}
                            </DropdownButton>
                        </div>
                        <div className="dfr">
                            <DropdownButton
                                title={
                                    <>
                                        <div className="dfr">
                                            <span>{t('LB_FB_ALL_UP_FORMULA')} : </span>
                                            <div className="dfc">{curAllupFormula}</div>
                                            <ArrowIcon direction="down" size={24} />
                                        </div>
                                    </>
                                }
                                align="end"
                                id="formulaText"
                                value={curAllupFormula}
                            >
                                {curFormulaText.map((item, index) => {
                                    return (
                                        <Dropdown.Item
                                            value={item}
                                            onClick={() => handleChangeSelect(item, 'formula', index)}
                                            active={curAllupFormula === item}
                                            key={item}
                                        >
                                            {item}
                                        </Dropdown.Item>
                                    );
                                })}
                            </DropdownButton>
                        </div>
                        <div className="dfr">
                            <DropdownButton
                                title={
                                    <>
                                        <div className="dfr">
                                            <span>{t('LB_RC_UNIT_BET')} : $ </span>
                                            <div className="dfc">{curUnitBet}</div>
                                            <ArrowIcon direction="down" size={24} />
                                        </div>
                                    </>
                                }
                                align="end"
                                id="unitbetrange"
                                value={curUnitBet}
                            >
                                {unitbetrange.map((item, index) => {
                                    return (
                                        <Dropdown.Item
                                            value={item}
                                            onClick={() => handleChangeSelect(item, 'unitBet')}
                                            active={curUnitBet === item}
                                            key={item}
                                        >
                                            {item}
                                        </Dropdown.Item>
                                    );
                                })}
                            </DropdownButton>
                        </div>
                    </div>
                    <div className="ftCalcSelection">
                        {isMobileSize ? (
                            <>
                                <div className="ftCalMTable">
                                    <div className=" ftCalMTableHeader bgColor">
                                        <div className="ftCalNum"></div>
                                        <div className="ftCalNumSelect">{t('LB_FB_SELECTIONS')}</div>
                                        <div className="ftCalFormula"></div>
                                        <div className="ftCalBetNo">{t('LB_RC_NO_OF_BETS')}</div>
                                    </div>
                                    {curLegChance?.map((item, index) => {
                                        return (
                                            <div
                                                className={`ftCalMTableRow ${index % 2 ? 'bgColor' : ''} ${
                                                    index == 7 ? 'lastDDSelect' : ''
                                                }`}
                                                key={new Date().getTime() + index}
                                            >
                                                <div className="ftCalNum">{formulaHeader[langIndex][index]}</div>
                                                <div className="ftCalNumSelect">
                                                    <DropdownButton
                                                        title={
                                                            <>
                                                                {curLegSelect[index]}
                                                                <ArrowIcon direction="down" size={24} />
                                                            </>
                                                        }
                                                        align="start"
                                                        id="legSelection"
                                                        drop={index == 7 ? 'up' : 'down'}
                                                        value={curLegSelect[index]}
                                                    >
                                                        {selection.map((item, indexs) => {
                                                            return (
                                                                <Dropdown.Item
                                                                    value={item}
                                                                    onClick={() =>
                                                                        handleChangeSelect(item, 'legSelection', index)
                                                                    }
                                                                    active={curLegSelect[index] === item}
                                                                    key={item}
                                                                >
                                                                    {item}
                                                                </Dropdown.Item>
                                                            );
                                                        })}
                                                    </DropdownButton>
                                                </div>
                                                <div className="ftCalFormula">{chanceHeader[langIndex][index]}</div>
                                                <div className="ftCalBetNo">{curBetChance[index]}</div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="ftCalTable" id="ftCalTable">
                                    <div className=" ftCalColFirst">
                                        <div className="formulaRow bgColor"></div>
                                        <div className="betSelectRow dfc ">{t('LB_FB_SELECTIONS')}</div>
                                        <div className="formulaRow bgColor"></div>
                                        <div className="betSelectRow1 dfc ">{t('LB_RC_NO_OF_BETS')}</div>
                                    </div>
                                    {curLegChance.map((item, index) => {
                                        return (
                                            <div className="ftCalCol" key={new Date().getTime() + index}>
                                                <div className="formulaRow dfcc bgColor">
                                                    {formulaHeader[langIndex][index]}
                                                </div>
                                                <div className="betSelectRow dfcc ">
                                                    <DropdownButton
                                                        title={
                                                            <>
                                                                {curLegSelect[index]}
                                                                <ArrowIcon direction="down" size={24} />
                                                            </>
                                                        }
                                                        align="start"
                                                        id="legSelection"
                                                        value={curLegSelect[index]}
                                                    >
                                                        {selection.map((item, indexs) => {
                                                            return (
                                                                <Dropdown.Item
                                                                    value={item}
                                                                    onClick={() =>
                                                                        handleChangeSelect(item, 'legSelection', index)
                                                                    }
                                                                    active={curLegSelect[index] === item}
                                                                    key={item}
                                                                >
                                                                    {item}
                                                                </Dropdown.Item>
                                                            );
                                                        })}
                                                    </DropdownButton>
                                                </div>
                                                <div className="formulaRow dfcc bgColor">
                                                    {chanceHeader[langIndex][index]}
                                                </div>
                                                <div className="betSelectRow1 dfcc ">{curBetChance[index]}</div>
                                            </div>
                                        );
                                    })}
                                </div>

                                <div className=" ftCalColBG">
                                    <div className="formulaRow bgColor"></div>
                                    <div className="betSelectRow  "></div>
                                    <div className="formulaRow bgColor"></div>
                                    <div className="betSelectRow1  "></div>
                                </div>
                            </>
                        )}
                    </div>
                    <div className="ftCalcBotArea">
                        <div className="dfc">
                            <div>{t('LB_BS_TOTAL_NO_OF_BETS')}</div>
                            <div className="text">{getChance()}</div>
                        </div>
                        <div className="dfc">
                            <div>{t('LB_BS_Total_AMOUNT')}</div>
                            <div className="text" style={{fontSize: `${flexiFontSize(getTotalAmount())}px`}}>${getTotalAmount()}</div>
                        </div>
                    </div>
                </div>
            </div>
        )
    );
};

export default FTCalculator;
